import { render, staticRenderFns } from "./showProductGoal.vue?vue&type=template&id=585581d9&scoped=true"
import script from "./showProductGoal.vue?vue&type=script&lang=js"
export * from "./showProductGoal.vue?vue&type=script&lang=js"
import style0 from "./showProductGoal.vue?vue&type=style&index=0&id=585581d9&prod&lang=scss&scoped=scoped"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "585581d9",
  null
  
)

export default component.exports